module.exports = __webpack_public_path__ + "img/background-study-scoping.7810c634.jpg";